import { render, staticRenderFns } from "./TrainerSchools.vue?vue&type=template&id=5c5d835a&scoped=true&"
import script from "./TrainerSchools.vue?vue&type=script&lang=js&"
export * from "./TrainerSchools.vue?vue&type=script&lang=js&"
import style0 from "./TrainerSchools.vue?vue&type=style&index=0&id=5c5d835a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d835a",
  null
  
)

export default component.exports